import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
// Used with an empty value in UserWrapper by default for non-detached contexts
const DetachedPatientIdContext = createContext(undefined);
export const NonDetachedPatientIdProvider = ({ children, }) => (_jsx(DetachedPatientIdContext.Provider, Object.assign({ value: undefined }, { children: children })));
export const DetachedPatientIdProvider = DetachedPatientIdContext.Provider;
export const useDetachedPatientId = () => { var _a; return (_a = useContext(DetachedPatientIdContext)) !== null && _a !== void 0 ? _a : { patientId: undefined }; };
